export function isStringsSimilar(prev?: string, next?: string): boolean {
  return prev?.toLocaleLowerCase().startsWith(next?.toLocaleLowerCase() ?? "") ?? false;
}
